import type { WalletRelease } from './types';

export const FALLBACK_RELEASE: WalletRelease = {
  version: '4.0.37',
  publishedAt: '2026-04-01T18:51:14Z',
  assets: {
    windows: {
      x64: 'https://github.com/NewCapital/TWINS-go/releases/download/v4.0.37/twins-4.0.37-win64.zip'
    },
    mac: {
      arm64: 'https://github.com/NewCapital/TWINS-go/releases/download/v4.0.37/twins-4.0.37-osx-arm64.zip',
      x86_64: 'https://github.com/NewCapital/TWINS-go/releases/download/v4.0.37/twins-4.0.37-osx-x86_64.zip'
    },
    linux: {
      aarch64: 'https://github.com/NewCapital/TWINS-go/releases/download/v4.0.37/twins-4.0.37-aarch64-linux-gnu.tar.gz',
      arm: 'https://github.com/NewCapital/TWINS-go/releases/download/v4.0.37/twins-4.0.37-arm-linux-gnueabihf.tar.gz',
      x64: 'https://github.com/NewCapital/TWINS-go/releases/download/v4.0.37/twins-4.0.37-x86_64-linux-gnu.tar.gz'
    }
  }
};